import styled, {css} from 'styled-components';

import {hoverSelector} from '../../../../core/src/helpers/browser/hoverHelpers';
import {blendColors} from '../../../../core/src/models/helpers/colorHelpers';
import {center} from '../../styles/mixins';
import {makeSizeConstants} from '../../styles/styleHelpers';
import {ThemeContextType} from '../../theme/userThemeProvider';
import {findButtonColors} from './buttonConstants';
import {ButtonContent, ButtonContentProps} from './buttonContent';

/*
 * Style.
 */

const chevronWidths = makeSizeConstants('24px', '38px');

const StyledButtonContent = styled(ButtonContent)`
  ${center()};
  padding: 0;
  width: ${(p) => chevronWidths[p.size]};

  ${(p) => addBoxShadowStyles(p)};

  svg {
    margin-left: -3px;
  }
`;

// These box shadows are used to create the divider between the content and the chevron.
// Since they function more as borders, they should still appear in other themes.
function addBoxShadowStyles(props: ButtonContentProps & ThemeContextType) {
  const buttonColors = findButtonColors(props.theme);

  const hoverColor = blendColors(
    buttonColors[props.variant].backgroundHover(props.color),
    buttonColors[props.variant].chevronShadow(props.color),
  );

  if (props.isDisabled) {
    return css`
      box-shadow: -2px 0 0 ${buttonColors[props.variant].chevronShadow(props.color)};
    `;
  }

  return css`
    ${hoverSelector} {
      box-shadow: -2px 0 0 ${blendColors(hoverColor, buttonColors[props.variant].chevronShadow(props.color))};
    }

    box-shadow: -2px 0 0 ${buttonColors[props.variant].chevronShadow(props.color)};
  `;
}

/*
 * Component.
 */

export const ButtonChevronContent = StyledButtonContent;
